// extracted by mini-css-extract-plugin
export default {"root":"I33qvVlZQeyo8JIFi5YI"};